import React from 'react'
import { GamesCol } from './styles'
import { MatchupBox } from './MatchupBox'
import { EventGQL } from '../../../Api'
import { getShortDate } from '../../../Utils'
import { Spacer } from '../../Layout/Spacers/Spacers.styles'

type MatchupProps = {
  events: EventGQL[]
}

export const ChampionshipCon: React.FC<React.PropsWithChildren<MatchupProps>> = ({
  events,
}) => {
  const champEvent = events.find((ev) => ev.slugname.includes('champion'))
  return (
    <>
      <GamesCol>
        <Spacer h={85} />
        <div className="weekCon">
          <h3>Cash App Championship</h3>
          {champEvent && (
            <>
              {champEvent && <p>{getShortDate(champEvent.startTime)}</p>}
              {champEvent.location && <p>{champEvent.location}</p>}
            </>
          )}
        </div>
        {champEvent && (
          <MatchupBox key={champEvent.slugname} event={champEvent} championship={true} />
        )}
      </GamesCol>
    </>
  )
}
